import { WhatsAppIcon, buildWhatsAppLink } from "./Header";
import { resolveImageUrl } from "../../lib/api";

const HERO_IMAGE =
  "https://images.unsplash.com/photo-1488509082528-cefbba5ad692?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHx3b21hbiUyMHVzaW5nJTIwc21hcnRwaG9uZSUyMGNsb3NlJTIwdXB8ZW58MHx8fHwxNzkxOTc2NzQ5fDA&ixlib=rb-4.1.0&q=85";

export default function Hero({ whatsappNumber, content }) {
  const h = content?.hero || {};
  const eyebrow = h.eyebrow || "Celulares • Acessórios • Assistência Técnica";
  const line1 = h.line1 || "Tudo para o seu celular,";
  const line2 = h.line2 || "com assistência técnica";
  const line3 = h.line3 || "de confiança.";
  const paragraph = h.paragraph || "Atendimento próximo e personalizado, com entrega rápida na sua cidade e envio para todo o Brasil.";
  const ctaPrimary = h.cta_primary || "Explorar Catálogo";
  const ctaSecondary = h.cta_secondary || "Pedir no WhatsApp";
  const image = h.image_url ? resolveImageUrl(h.image_url) : HERO_IMAGE;
  const badgeTitle = h.badge_title || "Destaque da Semana";
  const badgeText = h.badge_text || "Smartphones e acessórios selecionados";

  return (
    <section className="py-20 md:py-28 px-6 max-w-6xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7">
          <div className="inline-block font-mono text-xs uppercase tracking-[0.2em] text-[var(--brand)] mb-4">
            {eyebrow}
          </div>
          <h1 className="text-4xl sm:text-6xl lg:text-[68px] font-display font-bold leading-[1.02] tracking-tight mb-6">
            <span className="ln"><span>{line1}</span></span>
            <span className="ln"><span>{line2}</span></span>
            <span className="ln"><span className="text-[var(--brand)]">{line3}</span></span>
          </h1>
          <p className="fade-in text-lg sm:text-xl text-[#5A534C] max-w-xl mb-8 leading-relaxed">
            {paragraph}
          </p>
          <div className="fade-in flex flex-wrap items-center gap-4">
            <a
              href="#catalogo"
              data-testid="hero-catalog-button"
              className="bg-[#1A1816] text-[var(--site-bg)] px-7 py-3.5 rounded-full font-display text-sm font-semibold hover:bg-[#332F2C] transition-colors"
            >
              {ctaPrimary}
            </a>
            <a
              href={buildWhatsAppLink(whatsappNumber, "Olá! Vim pelo catálogo online e quero fazer um pedido.")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-button"
              className="inline-flex items-center gap-2 border border-[#D5CDC2] text-[#1A1816] px-6 py-3.5 rounded-full font-display text-sm font-semibold hover:border-[#1A1816] transition-colors"
            >
              <WhatsAppIcon />
              <span>{ctaSecondary}</span>
            </a>
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-2xl border border-[#E8E2D9] group">
            <img
              src={image}
              alt="Destaque da loja"
              className="absolute inset-0 w-full h-full object-cover drift-slow"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent flex flex-col justify-end p-6">
              <span className="text-xs font-mono uppercase tracking-widest text-[var(--site-bg)]/80">{badgeTitle}</span>
              <p className="text-white font-display text-lg font-medium">{badgeText}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
